import { createBasePropertiesSchema, createBaseSchema, } from '../../documentManagement/createComponentSchema';
/**
 * @deprecated - Please use createDataSchema instead (import {createDataSchema} from '@wix/editor-elements-integrations')
 */
export const createYupDataSchema = createBasePropertiesSchema;
/**
 * @deprecated - Please use createPropertiesSchema instead  (import {createPropertiesSchema} from '@wix/editor-elements-integrations')
 */
export const createYupPropertiesSchema = createBaseSchema;
//# sourceMappingURL=index.js.map